import ApprovalCoursePage from 'pages/public/SME/ApprovalCourse';
import SMECourseEntryPage from 'pages/public/SME/CourseEntry';
import SharedMasterPlanDetailPage from 'pages/public/DACUM/SharedMasterPlanDetail';

export const pathnames = {
  smeInputCourse: '/public/lcms/submit-sme',
  approvalCourse: '/public/lcms/submit-pic',
  sharedMasterPlan: '/app/dacum/masterplan/shared/:id'
};

const PublicRoutes = [
  {
    path: pathnames.smeInputCourse,
    element: <SMECourseEntryPage />
  },
  {
    path: pathnames.approvalCourse,
    element: <ApprovalCoursePage />
  },
  {
    path: pathnames.sharedMasterPlan,
    element: <SharedMasterPlanDetailPage />
  }
];

export default PublicRoutes;
